<template>
  <div class="filter__body">
    <div class="title__body">
      <div class="w-100 mr-3">
        <span>{{ t("subject") }}</span>
        <select v-model.number="localSubject" class="selectFilter">
          <option :value="-1">{{ t("all_subjects") }}</option>
          <option
            v-for="(item, index) in subjectList"
            :key="`subject-${index}`"
            :value="item.id"
          >
            {{ item.text }}
          </option>
        </select>
      </div>

      <div class="w-100 mr-3">
        <span>{{ t("date") }}</span>
        <input v-model="localDate" type="date" class="date__custom__body" />
      </div>

      <div class="w-100">
        <span>{{ t("status_title") }}</span>
        <select v-model.number="localStatus" class="selectFilter">
          <option :value="-1">{{ t("all") }}</option>
          <option
            v-for="(item, index) in statusList"
            :key="`status-${index}`"
            :value="index"
          >
            {{ item }}
          </option>
        </select>
      </div>

      <div class="btn__big__size" v-if="heightSize > 950">
        <button
          class="btn button__body__filter clear__btn"
          type="button"
          @click="onClear"
        >
          {{ t("clear") }}
        </button>
      </div>
    </div>

    <div class="buttons__group__filter">
      <button class="btn button__body__filter btn-success" type="button" @click="onApply">
        {{ t("show") }}
      </button>
      <button
        class="btn button__body__filter mt-2 clear__btn"
        type="button"
        @click="onClear"
      >
        {{ t("clear") }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  subjectList: {
    type: Array,
    default: () => [],
  },
  statusList: {
    type: Array,
    default: () => [],
  },
  subject: {
    type: Number,
    default: -1,
  },
  date: {
    type: String,
    default: "",
  },
  status: {
    type: Number,
    default: -1,
  },
  heightSize: {
    type: Number,
    default: 1200,
  },
});

const emit = defineEmits(["apply", "clear"]);
const { t } = useI18n();

const localSubject = ref(props.subject);
const localDate = ref(props.date);
const localStatus = ref(props.status);

watch(
  () => [props.subject, props.date, props.status],
  ([subject, date, status]) => {
    localSubject.value = subject;
    localDate.value = date;
    localStatus.value = status;
  }
);

watch([localSubject, localDate, localStatus], () => {
  if (props.heightSize >= 950) onApply();
});

function onApply() {
  emit("apply", {
    subject: Number(localSubject.value || -1),
    date: localDate.value || "",
    status: Number(localStatus.value || -1),
  });
}

function onClear() {
  localSubject.value = -1;
  localDate.value = "";
  localStatus.value = -1;
  emit("clear");
}
</script>

<style scoped lang="scss">
.btn__big__size {
  @media screen and (max-width: 768px) {
    display: none;
  }

  @media screen and (min-width: 768px) {
    display: flex;
    align-items: flex-end;
    margin-bottom: 1px;
  }
}

.selectFilter {
  height: 42px !important;
  margin-top: 8px;
  display: inline-block;
  width: 100%;
  padding: 0.375rem 5px 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  padding-right: 20px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%);
  background-position: calc(100% - 17px) calc(1em + 2px),
    calc(100% - 12px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px;
  background-repeat: no-repeat;
}

.date__custom__body {
  height: 42px !important;
  margin-top: 8px;
  display: inline-block;
  width: 100%;
  padding: 0 5px 0 10px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.clear__btn {
  font-family: Roboto, sans-serif;
  font-style: normal;
  background: #e0e0e0 !important;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.24);
  border-radius: 2px;
}

.title__body {
  width: 100%;
  display: flex;
  gap: 8px;
  flex-direction: column;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  justify-content: space-between;

  @media screen and (max-width: 950px) {
    height: 240px;
  }

  @media screen and (min-width: 950px) {
    display: flex;
    flex-direction: row;
    padding: 0 16px;
  }
}

.filter__body {
  display: flex;
  gap: 8px;
  @media screen and (max-width: 767px) {
    margin-left: 0 !important;
    top: 50px !important;
  }

  @media screen and (max-width: 950px) {
    padding: 20px;
    left: 0;
    right: 0;
    top: 72px;
    position: absolute;
    z-index: 100001;
    background: #fff;
    bottom: 50px;
    margin-left: 470px;
  }

  @media screen and (min-width: 950px) {
    padding: 10px 20px 20px;
    margin-top: 22px;
    left: 0;
    right: 0;
  }
}

.buttons__group__filter {
  flex-direction: column;
  align-items: center;
  bottom: 10px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 16px;

  @media screen and (max-width: 950px) {
    display: flex;
  }

  @media screen and (min-width: 950px) {
    display: none;
  }

  .button__body__filter {
    padding: 4px 20px !important;
    border: none !important;
    height: 36px;
    background: #36b453;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.24);
    border-radius: 2px;
    width: 100%;
  }
}
</style>
